(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9826,2576,5124,949,1620,8960],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 30866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ journeys; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 3 modules
var DemoForm = __webpack_require__(98960);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(29412);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(83820);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(47096);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Hero/Hero.tsx









var copy = {
  overline: "Journeys",
  heading: "Build trust and improve performance",
  description: "Unlock additional value and engage customers with personalized messages, when they need them and over the channel they prefer."
};
var FORM_ID = "journeys-demo-request";

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          tag: "h5",
          variant: "h5",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            isProgressive: true,
            customFormIdentifier: FORM_ID,
            customTrackingType: FORM_ID
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "533",
            height: "404",
            src: (Hero_2x_default()),
            alt: ""
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e3jtken1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("lg");
}, "{padding-top:0;}" + ( true ? "" : 0));

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e3jtken0"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("lg");
}, "{text-align:left;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var templates_LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/LogoCarousel/LogoCarousel.tsx





var logos = [data/* carouselLogos.ROKFIN */.j.ROKFIN, data/* carouselLogos.TOGGLE */.j.TOGGLE, data/* carouselLogos.GOOD_EGGS */.j.GOOD_EGGS, data/* carouselLogos.ALLERGAN */.j.ALLERGAN, data/* carouselLogos.DOMINOS */.j.DOMINOS, data/* carouselLogos.SANOFI */.j.SANOFI, data/* carouselLogos.BOX */.j.BOX, data/* carouselLogos.CRAFTJACK */.j.CRAFTJACK, data/* carouselLogos.VACASA */.j.VACASA];

var LogoCarousel = function LogoCarousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(templates_LogoCarousel["default"], {
        logos: logos
      })
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e9fllfk0"
} : 0)(Section/* Wrapper */.im, "{padding-top:4px;padding-bottom:4px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{padding-top:44px;padding-bottom:20px;}}" + ( true ? "" : 0));

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarousel);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 257 modules
var CompanyMono = __webpack_require__(41346);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Testimonial/Testimonial.tsx







var Testimonial_copy = {
  description: "\u201CThe biggest thing Segment CDP has given us is flexibility. We\u2019re able to focus on the most optimal journey and know that it will be possible; any experience we want for our customers we can deliver downstream to them.\u201D",
  author: "Laura Brodie",
  role: "Director of Customer Lifecycle and Growth"
};

var TestimonialComponent = function TestimonialComponent() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* default */.ZP, {
        variant: "base",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
          height: "auto",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RitualMonoLogo */.qWP, {
                color: "".concat(theme.palette.neutrals.white["100"])
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
              children: Testimonial_copy.description
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseAuthorSlot */.hC, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
                children: Testimonial_copy.author
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
                children: Testimonial_copy.role
              })]
            })
          })]
        })
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e16tgdj20"
} : 0)(Section/* Wrapper */.im, "{row-gap:0;", Section/* Contents */.AU, "{max-width:900px;}}" + ( true ? "" : 0));

/* harmony default export */ var Testimonial_Testimonial = (TestimonialComponent);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Video/assets/Cover@2x.png
var Cover_2x = __webpack_require__(92179);
var Cover_2x_default = /*#__PURE__*/__webpack_require__.n(Cover_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Video/assets/Cover.webp
var Cover = __webpack_require__(25149);
var Cover_default = /*#__PURE__*/__webpack_require__.n(Cover);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Video/assets/Cover@2x.webp
var assets_Cover_2x = __webpack_require__(35816);
var assets_Cover_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Cover_2x);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Video/CoverImage.tsx








var CoverImage = function CoverImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((Cover_default()), ", ").concat((assets_Cover_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: 832,
        height: 473,
        src: (Cover_2x_default()),
        alt: ""
      })]
    })
  });
};

/* harmony default export */ var Video_CoverImage = (CoverImage);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Video/Video.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Video = function Video() {
  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledElevation, {
        elevation: 6,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
          url: "https://player.vimeo.com/video/559103187?badge=0&autopause=0&player_id=0&app_id=58479",
          playing: playing,
          onPause: function onPause() {
            stop();
          },
          onPlay: function onPlay() {
            play();
          },
          children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
            onClick: play
          }, "play-btn"), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_CoverImage, {}, "cover")]
        })
      })
    })
  });
};

var Video_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1bkxt7c1"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:64px;}}" + ( true ? "" : 0));

var StyledElevation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "e1bkxt7c0"
} : 0)( true ? {
  name: "jz9lbu",
  styles: "margin:0 auto;max-width:832px"
} : 0);

/* harmony default export */ var Video_Video = (Video);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/MakeItAContinuousConversation/assets/MakeItAContinuousConversation@2x.png
var MakeItAContinuousConversation_2x = __webpack_require__(51318);
var MakeItAContinuousConversation_2x_default = /*#__PURE__*/__webpack_require__.n(MakeItAContinuousConversation_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/MakeItAContinuousConversation/assets/MakeItAContinuousConversation.webp
var MakeItAContinuousConversation = __webpack_require__(16116);
var MakeItAContinuousConversation_default = /*#__PURE__*/__webpack_require__.n(MakeItAContinuousConversation);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/MakeItAContinuousConversation/assets/MakeItAContinuousConversation@2x.webp
var assets_MakeItAContinuousConversation_2x = __webpack_require__(38456);
var assets_MakeItAContinuousConversation_2x_default = /*#__PURE__*/__webpack_require__.n(assets_MakeItAContinuousConversation_2x);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/MakeItAContinuousConversation/MakeItAContinuousConversationImage.tsx







var MakeItAContinuousConversationImage = function MakeItAContinuousConversationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((MakeItAContinuousConversation_default()), ", ").concat((assets_MakeItAContinuousConversation_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "585",
      height: "411",
      src: (MakeItAContinuousConversation_2x_default()),
      alt: "Illustration: Make it a continuous conversation",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var MakeItAContinuousConversation_MakeItAContinuousConversationImage = (MakeItAContinuousConversationImage);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/MakeItAContinuousConversation/MakeItAContinuousConversation.tsx






var MakeItAContinuousConversation_copy = {
  heading: "Make it a continuous conversation",
  description: "Build personalized customer journeys across tools and platforms based on rich, real-time data collection."
};

var MakeItAContinuousConversation_MakeItAContinuousConversation = function MakeItAContinuousConversation() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: MakeItAContinuousConversation_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          children: MakeItAContinuousConversation_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeItAContinuousConversation_MakeItAContinuousConversationImage, {})
    })]
  });
};

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e135glen0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var components_MakeItAContinuousConversation_MakeItAContinuousConversation = (MakeItAContinuousConversation_MakeItAContinuousConversation);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/OrchestrateTheOutcomes/assets/OrchestrateTheOutcomes@2x.png
var OrchestrateTheOutcomes_2x = __webpack_require__(1504);
var OrchestrateTheOutcomes_2x_default = /*#__PURE__*/__webpack_require__.n(OrchestrateTheOutcomes_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/OrchestrateTheOutcomes/assets/OrchestrateTheOutcomes.webp
var OrchestrateTheOutcomes = __webpack_require__(8801);
var OrchestrateTheOutcomes_default = /*#__PURE__*/__webpack_require__.n(OrchestrateTheOutcomes);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/OrchestrateTheOutcomes/assets/OrchestrateTheOutcomes@2x.webp
var assets_OrchestrateTheOutcomes_2x = __webpack_require__(75720);
var assets_OrchestrateTheOutcomes_2x_default = /*#__PURE__*/__webpack_require__.n(assets_OrchestrateTheOutcomes_2x);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/OrchestrateTheOutcomes/OrchestrateTheOutcomesImage.tsx







var OrchestrateTheOutcomesImage = function OrchestrateTheOutcomesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((OrchestrateTheOutcomes_default()), ", ").concat((assets_OrchestrateTheOutcomes_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "399",
      height: "369",
      src: (OrchestrateTheOutcomes_2x_default()),
      alt: "Illustration: Orchestrate the outcomes you want",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var OrchestrateTheOutcomes_OrchestrateTheOutcomesImage = (OrchestrateTheOutcomesImage);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/OrchestrateTheOutcomes/OrchestrateTheOutcomes.tsx


function OrchestrateTheOutcomes_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var OrchestrateTheOutcomes_copy = {
  heading: "Orchestrate the outcomes you want",
  description: "Design multi-step interactions that drive to results with a user-friendly visual builder."
};

var OrchestrateTheOutcomes_OrchestrateTheOutcomes = function OrchestrateTheOutcomes() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrchestrateTheOutcomes_SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: OrchestrateTheOutcomes_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          children: OrchestrateTheOutcomes_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrchestrateTheOutcomes_OrchestrateTheOutcomesImage, {})
    })]
  });
};

var OrchestrateTheOutcomes_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1ntw5of1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

var SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1ntw5of0"
} : 0)( true ? {
  name: "1nm10lp",
  styles: "margin:0 auto;max-width:399px"
} : 0);

/* harmony default export */ var components_OrchestrateTheOutcomes_OrchestrateTheOutcomes = (OrchestrateTheOutcomes_OrchestrateTheOutcomes);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannelsMobile@2x.png
var UnitePaidAndOwnedChannelsMobile_2x = __webpack_require__(57014);
var UnitePaidAndOwnedChannelsMobile_2x_default = /*#__PURE__*/__webpack_require__.n(UnitePaidAndOwnedChannelsMobile_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannelsMobile.webp
var UnitePaidAndOwnedChannelsMobile = __webpack_require__(23910);
var UnitePaidAndOwnedChannelsMobile_default = /*#__PURE__*/__webpack_require__.n(UnitePaidAndOwnedChannelsMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannelsMobile@2x.webp
var assets_UnitePaidAndOwnedChannelsMobile_2x = __webpack_require__(70168);
var assets_UnitePaidAndOwnedChannelsMobile_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UnitePaidAndOwnedChannelsMobile_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannels.png
var UnitePaidAndOwnedChannels = __webpack_require__(52196);
var UnitePaidAndOwnedChannels_default = /*#__PURE__*/__webpack_require__.n(UnitePaidAndOwnedChannels);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannels@2x.png
var UnitePaidAndOwnedChannels_2x = __webpack_require__(8977);
var UnitePaidAndOwnedChannels_2x_default = /*#__PURE__*/__webpack_require__.n(UnitePaidAndOwnedChannels_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannels.webp
var assets_UnitePaidAndOwnedChannels = __webpack_require__(98546);
var assets_UnitePaidAndOwnedChannels_default = /*#__PURE__*/__webpack_require__.n(assets_UnitePaidAndOwnedChannels);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/assets/UnitePaidAndOwnedChannels@2x.webp
var assets_UnitePaidAndOwnedChannels_2x = __webpack_require__(3079);
var assets_UnitePaidAndOwnedChannels_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UnitePaidAndOwnedChannels_2x);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/UnitePaidAndOwnedChannelsImage.tsx













var UnitePaidAndOwnedChannelsImage = function UnitePaidAndOwnedChannelsImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        media: theme.breakpoints.up("sm", false),
        srcSet: "".concat((assets_UnitePaidAndOwnedChannels_default()), ", ").concat((assets_UnitePaidAndOwnedChannels_2x_default()), " 2x"),
        width: "1068",
        height: "468"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        media: theme.breakpoints.up("sm", false),
        srcSet: "".concat((UnitePaidAndOwnedChannels_default()), ", ").concat((UnitePaidAndOwnedChannels_2x_default()), " 2x"),
        width: "1068",
        height: "468"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((UnitePaidAndOwnedChannelsMobile_default()), ", ").concat((assets_UnitePaidAndOwnedChannelsMobile_2x_default()), " 2x"),
        width: "342",
        height: "550"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "320",
        height: "600",
        src: (UnitePaidAndOwnedChannelsMobile_2x_default()),
        alt: "Illustration: Unite paid and owned channels",
        loading: "lazy"
      })]
    })
  });
};

/* harmony default export */ var UnitePaidAndOwnedChannels_UnitePaidAndOwnedChannelsImage = (UnitePaidAndOwnedChannelsImage);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/UnitePaidAndOwnedChannels/UnitePaidAndOwnedChannels.tsx


function UnitePaidAndOwnedChannels_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var UnitePaidAndOwnedChannels_copy = {
  heading: "Unite paid and owned channels",
  description: "Build audiences that live across every channel in your marketing strategy, and every tool in your stack."
};

var UnitePaidAndOwnedChannels_UnitePaidAndOwnedChannels = function UnitePaidAndOwnedChannels() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnitePaidAndOwnedChannels_SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: UnitePaidAndOwnedChannels_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          children: UnitePaidAndOwnedChannels_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnitePaidAndOwnedChannels_UnitePaidAndOwnedChannelsImage, {})
    })]
  });
};

var UnitePaidAndOwnedChannels_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "er3rptn0"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

/* harmony default export */ var components_UnitePaidAndOwnedChannels_UnitePaidAndOwnedChannels = (UnitePaidAndOwnedChannels_UnitePaidAndOwnedChannels);
// EXTERNAL MODULE: ../../libs/templates/Testimonial/index.ts + 2 modules
var templates_Testimonial = __webpack_require__(5099);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/Testimonials/Testimonials.tsx





var Testimonials = function Testimonials() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(templates_Testimonial/* default */.Z, {
      variant: "extended",
      company: "theVintageBar"
    })
  });
};

var Testimonials_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ehgz4uq0"
} : 0)("max-width:1260px;overflow-x:inherit;", Section/* Wrapper */.im, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:80px;padding-bottom:80px;}}" + ( true ? "" : 0));

/* harmony default export */ var Testimonials_Testimonials = (Testimonials);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/FaqImage.tsx





var FaqImage = function FaqImage(_ref) {
  var alt = _ref.alt,
      mobile = _ref.mobile,
      desktop = _ref.desktop,
      mobileWebp = _ref.mobileWebp,
      desktopWebp = _ref.desktopWebp,
      height = _ref.height;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("lg", false),
      srcSet: "".concat(desktopWebp),
      width: "844",
      height: height
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("lg", false),
      srcSet: "".concat(desktop),
      width: "844",
      height: height
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(mobileWebp),
      width: "576",
      height: height
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: mobile,
      alt: "Illustration: ".concat(alt),
      width: "844",
      height: height,
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Faq_FaqImage = (FaqImage);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/ReEngagementDesktop.png
var ReEngagementDesktop = __webpack_require__(1736);
var ReEngagementDesktop_default = /*#__PURE__*/__webpack_require__.n(ReEngagementDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/ReEngagementMobile.png
var ReEngagementMobile = __webpack_require__(13842);
var ReEngagementMobile_default = /*#__PURE__*/__webpack_require__.n(ReEngagementMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/ReEngagementDesktop.webp
var assets_ReEngagementDesktop = __webpack_require__(414);
var assets_ReEngagementDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_ReEngagementDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/ReEngagementMobile.webp
var assets_ReEngagementMobile = __webpack_require__(27643);
var assets_ReEngagementMobile_default = /*#__PURE__*/__webpack_require__.n(assets_ReEngagementMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/RepeatPurchaseCampaignsDesktop.png
var RepeatPurchaseCampaignsDesktop = __webpack_require__(17436);
var RepeatPurchaseCampaignsDesktop_default = /*#__PURE__*/__webpack_require__.n(RepeatPurchaseCampaignsDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/RepeatPurchaseCampaignsMobile.png
var RepeatPurchaseCampaignsMobile = __webpack_require__(87534);
var RepeatPurchaseCampaignsMobile_default = /*#__PURE__*/__webpack_require__.n(RepeatPurchaseCampaignsMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/RepeatPurchaseCampaignsDesktop.webp
var assets_RepeatPurchaseCampaignsDesktop = __webpack_require__(43576);
var assets_RepeatPurchaseCampaignsDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_RepeatPurchaseCampaignsDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/RepeatPurchaseCampaignsMobile.webp
var assets_RepeatPurchaseCampaignsMobile = __webpack_require__(82052);
var assets_RepeatPurchaseCampaignsMobile_default = /*#__PURE__*/__webpack_require__.n(assets_RepeatPurchaseCampaignsMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/TrialToPaidConversionDesktop.png
var TrialToPaidConversionDesktop = __webpack_require__(38267);
var TrialToPaidConversionDesktop_default = /*#__PURE__*/__webpack_require__.n(TrialToPaidConversionDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/TrialToPaidConversionMobile.png
var TrialToPaidConversionMobile = __webpack_require__(84738);
var TrialToPaidConversionMobile_default = /*#__PURE__*/__webpack_require__.n(TrialToPaidConversionMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/TrialToPaidConversionDesktop.webp
var assets_TrialToPaidConversionDesktop = __webpack_require__(18470);
var assets_TrialToPaidConversionDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_TrialToPaidConversionDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/TrialToPaidConversionMobile.webp
var assets_TrialToPaidConversionMobile = __webpack_require__(71536);
var assets_TrialToPaidConversionMobile_default = /*#__PURE__*/__webpack_require__.n(assets_TrialToPaidConversionMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/CartAbandonmentDesktop.png
var CartAbandonmentDesktop = __webpack_require__(57766);
var CartAbandonmentDesktop_default = /*#__PURE__*/__webpack_require__.n(CartAbandonmentDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/CartAbandonmentMobile.png
var CartAbandonmentMobile = __webpack_require__(35811);
var CartAbandonmentMobile_default = /*#__PURE__*/__webpack_require__.n(CartAbandonmentMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/CartAbandonmentDesktop.webp
var assets_CartAbandonmentDesktop = __webpack_require__(11432);
var assets_CartAbandonmentDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_CartAbandonmentDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/CartAbandonmentMobile.webp
var assets_CartAbandonmentMobile = __webpack_require__(27144);
var assets_CartAbandonmentMobile_default = /*#__PURE__*/__webpack_require__.n(assets_CartAbandonmentMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/LowRecencyPurchaseWinbackDesktop.png
var LowRecencyPurchaseWinbackDesktop = __webpack_require__(18564);
var LowRecencyPurchaseWinbackDesktop_default = /*#__PURE__*/__webpack_require__.n(LowRecencyPurchaseWinbackDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/LowRecencyPurchaseWinbackMobile.png
var LowRecencyPurchaseWinbackMobile = __webpack_require__(24924);
var LowRecencyPurchaseWinbackMobile_default = /*#__PURE__*/__webpack_require__.n(LowRecencyPurchaseWinbackMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/LowRecencyPurchaseWinbackDesktop.webp
var assets_LowRecencyPurchaseWinbackDesktop = __webpack_require__(25265);
var assets_LowRecencyPurchaseWinbackDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_LowRecencyPurchaseWinbackDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/LowRecencyPurchaseWinbackMobile.webp
var assets_LowRecencyPurchaseWinbackMobile = __webpack_require__(66558);
var assets_LowRecencyPurchaseWinbackMobile_default = /*#__PURE__*/__webpack_require__.n(assets_LowRecencyPurchaseWinbackMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/OnboardingDesktop.png
var OnboardingDesktop = __webpack_require__(18093);
var OnboardingDesktop_default = /*#__PURE__*/__webpack_require__.n(OnboardingDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/OnboardingMobile.png
var OnboardingMobile = __webpack_require__(58015);
var OnboardingMobile_default = /*#__PURE__*/__webpack_require__.n(OnboardingMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/OnboardingDesktop.webp
var assets_OnboardingDesktop = __webpack_require__(54872);
var assets_OnboardingDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_OnboardingDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/OnboardingMobile.webp
var assets_OnboardingMobile = __webpack_require__(99188);
var assets_OnboardingMobile_default = /*#__PURE__*/__webpack_require__.n(assets_OnboardingMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/PaidSubscriptionAcquisitionDesktop.png
var PaidSubscriptionAcquisitionDesktop = __webpack_require__(43400);
var PaidSubscriptionAcquisitionDesktop_default = /*#__PURE__*/__webpack_require__.n(PaidSubscriptionAcquisitionDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/PaidSubscriptionAcquisitionMobile.png
var PaidSubscriptionAcquisitionMobile = __webpack_require__(26910);
var PaidSubscriptionAcquisitionMobile_default = /*#__PURE__*/__webpack_require__.n(PaidSubscriptionAcquisitionMobile);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/PaidSubscriptionAcquisitionDesktop.webp
var assets_PaidSubscriptionAcquisitionDesktop = __webpack_require__(53194);
var assets_PaidSubscriptionAcquisitionDesktop_default = /*#__PURE__*/__webpack_require__.n(assets_PaidSubscriptionAcquisitionDesktop);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/assets/PaidSubscriptionAcquisitionMobile.webp
var assets_PaidSubscriptionAcquisitionMobile = __webpack_require__(28807);
var assets_PaidSubscriptionAcquisitionMobile_default = /*#__PURE__*/__webpack_require__.n(assets_PaidSubscriptionAcquisitionMobile);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/data.tsx






























var data_data = [{
  title: "Cart Abandonment",
  description: "Win back users to drive purchases while optimizing ad spend and discounting.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Cart Abandonment",
    desktop: (CartAbandonmentDesktop_default()),
    mobile: (CartAbandonmentMobile_default()),
    desktopWebp: (assets_CartAbandonmentDesktop_default()),
    mobileWebp: (assets_CartAbandonmentMobile_default()),
    height: 670
  })
}, {
  title: "Repeat Purchase Campaigns",
  description: "Convert one-time buyers by delivering communications in their preferred channels.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Repeat Purchase Campaigns",
    desktop: (RepeatPurchaseCampaignsDesktop_default()),
    mobile: (RepeatPurchaseCampaignsMobile_default()),
    desktopWebp: (assets_RepeatPurchaseCampaignsDesktop_default()),
    mobileWebp: (assets_RepeatPurchaseCampaignsMobile_default()),
    height: 600
  })
}, {
  title: "Low Recency Purchase Winback",
  description: "Drive returning purchases with personalized discounts based on intent signals.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Low Recency Purchase Winback",
    desktop: (LowRecencyPurchaseWinbackDesktop_default()),
    mobile: (LowRecencyPurchaseWinbackMobile_default()),
    desktopWebp: (assets_LowRecencyPurchaseWinbackDesktop_default()),
    mobileWebp: (assets_LowRecencyPurchaseWinbackMobile_default()),
    height: 666
  })
}, {
  title: "Trial to Paid Conversion",
  description: "Engage the right messaging at the right time in all the right channels.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Trial to Paid Conversion",
    desktop: (TrialToPaidConversionDesktop_default()),
    mobile: (TrialToPaidConversionMobile_default()),
    desktopWebp: (assets_TrialToPaidConversionDesktop_default()),
    mobileWebp: (assets_TrialToPaidConversionMobile_default()),
    height: 522
  })
}, {
  title: "Onboarding",
  description: "Guide users through onboarding based on real-time behavior.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Onboarding",
    desktop: (OnboardingDesktop_default()),
    mobile: (OnboardingMobile_default()),
    desktopWebp: (assets_OnboardingDesktop_default()),
    mobileWebp: (assets_OnboardingMobile_default()),
    height: 522
  })
}, {
  title: "Re-engagement",
  description: "Design personalized messaging based on user preferences and behavior.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Re-engagement",
    desktop: (ReEngagementDesktop_default()),
    mobile: (ReEngagementMobile_default()),
    desktopWebp: (assets_ReEngagementDesktop_default()),
    mobileWebp: (assets_ReEngagementMobile_default()),
    height: 683
  })
}, {
  title: "Paid Subscription Acquisition",
  description: "Engage at the right time with personalized messaging to drive conversions.",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FaqImage, {
    alt: "Paid Subscription Acquisition",
    desktop: (PaidSubscriptionAcquisitionDesktop_default()),
    mobile: (PaidSubscriptionAcquisitionMobile_default()),
    desktopWebp: (assets_PaidSubscriptionAcquisitionDesktop_default()),
    mobileWebp: (assets_PaidSubscriptionAcquisitionMobile_default()),
    height: 670
  })
}];

;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/Faq/Faq.tsx







var Faq = function Faq() {
  var items = Array(data_data.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_Wrapper, {
    children: activeItems.map(function (active, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
          onClick: function onClick() {
            return toggle(index);
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* TitleWrapper */.$t, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
              opened: active,
              children: data_data[index].title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* SubTitle */.DK, {
              children: data_data[index].description
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
            opened: active
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
          children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
            children: data_data[index].image
          })
        })]
      }, "item-".concat(index));
    })
  });
};

var Faq_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1tayprb0"
} : 0)( true ? "" : 0);

/* harmony default export */ var Faq_Faq = (Faq);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/ChooseYourOwnJourney/ChooseYourOwnJourney.tsx








var ChooseYourOwnJourney_copy = {
  title: "Choose your own journey",
  description: "Grow and retain across the customer lifecycle with our standard starter templates."
};
var ChooseYourOwnJourney_link = {
  text: "Learn more about Journeys",
  url: "https://learn.segment.com/journeys-orchestrating-omnichannel-engagement/"
};

var ChooseYourOwnJourney = function ChooseYourOwnJourney() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBaseWrapper, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChooseYourOwnJourney_StyledSectionBase, {
        variant: "centered",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              children: ChooseYourOwnJourney_copy.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              children: ChooseYourOwnJourney_copy.description
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_Faq, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          tag: "a",
          href: ChooseYourOwnJourney_link.url,
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: ChooseYourOwnJourney_link.text
        })]
      })
    })
  });
};

/* harmony default export */ var ChooseYourOwnJourney_ChooseYourOwnJourney = (ChooseYourOwnJourney);

var SectionBaseWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eewuxrb1"
} : 0)(Section/* Wrapper */.im, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:0;padding-bottom:0;}}" + ( true ? "" : 0));

var ChooseYourOwnJourney_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eewuxrb0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;row-gap:48px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:72px;padding-top:80px;padding-bottom:120px;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{text-align:left;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("xs");
}, "{padding:0 0 50px;}}", Section/* Contents */.AU, "{justify-content:left;max-width:832px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{text-align:center;max-width:751px;}}", Section/* Copy */.CK, "{", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{min-width:832px;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-html-renderer/dist/rich-text-html-renderer.es5.js
var rich_text_html_renderer_es5 = __webpack_require__(11752);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/FaqSection/data.tsx

var faqData = [{
  question: "What does customer journey management mean?",
  answer: {
    content: [{
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "Customer journey management is the process of mapping out, analyzing, and optimizing a person\u2019s interactions\n              with a brand, often with the goal of nudging them toward a conversion, strengthening their loyalty, or turning\n              them into brand advocates. Customer journey management takes a look at each funnel stage and how different\n              personas move through them \u2013 tracking and measuring each person\u2019s engagement, actions, or points of friction to\n              improve the overall user experience."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  question: "What customer channels can I track and manage in Journeys?",
  answer: {
    content: [{
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "Journeys helps businesses orchestrate multi-step, multi-channel customer journeys at scale using real-time data. Businesses can connect Journeys to any tool in their tech stack to engage users on any channel, such as live chat, push notifications, paid and organic social media channels, and more."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }, {
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "However, businesses can also connect Journeys to any tool in their tech stack to engage users on any channel,\n              such as live chat, push notifications, paid and organic social media channels, and more."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  question: "Is journey mapping software the same as journey management software?",
  answer: {
    content: [{
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "Usually, journey mapping tools take a retroactive look at the way a user has interacted with the business to\n              understand the most common pain points or paths to acquisition."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }, {
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "A customer journey management tool, however, takes a more strategic approach. It helps build and orchestrate\n              customer journeys based on a person\u2019s behavioral history, interests, job title, engagement rates and more."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }, {
      content: [{
        data: {},
        marks: [],
        nodeType: "text",
        value: "Twilio Segment helps you do both of these things with Journeys. Businesses are able to unify their customer\n              data into profiles, which help them map out, analyze, and iterate on the complete customer experience. It also\n              offers teams the ability to activate this data by orchestrating multi-step customer experiences (across\n              channels) that automatically adapt based on someone\u2019s real-time behavior."
      }],
      data: {},
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}];
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/FaqSection/FaqSection.tsx










var FaqSection_copy = {
  heading: "Frequently asked questions"
};

var FaqSection = function FaqSection() {
  var items = new Array(faqData.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        children: FaqSection_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* JsonLdFaq */.yD, {
        data: faqData.map(function (_ref) {
          var answer = _ref.answer,
              question = _ref.question;
          return {
            question: question,
            answer: (0,rich_text_html_renderer_es5/* documentToHtmlString */.S)(answer)
          };
        })
      }), activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                tag: "h3",
                opened: active,
                children: faqData[index].question
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                data: faqData[index].answer
              })
            })
          })]
        }, "item-".concat(index));
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ekv9uxt1"
} : 0)("padding-bottom:28px;text-align:center;margin-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:44px;}" + ( true ? "" : 0));

var FaqSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ekv9uxt0"
} : 0)("max-width:1004px;overflow-x:unset;", Section/* Wrapper */.im, "{padding-top:0;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("xs");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var FaqSection_FaqSection = (FaqSection);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/BuildDeeper/assets/BuildDeeper@2x.png
var BuildDeeper_2x = __webpack_require__(85806);
var BuildDeeper_2x_default = /*#__PURE__*/__webpack_require__.n(BuildDeeper_2x);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/BuildDeeper/assets/BuildDeeper.webp
var BuildDeeper = __webpack_require__(50444);
var BuildDeeper_default = /*#__PURE__*/__webpack_require__.n(BuildDeeper);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/BuildDeeper/assets/BuildDeeper@2x.webp
var assets_BuildDeeper_2x = __webpack_require__(42138);
var assets_BuildDeeper_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BuildDeeper_2x);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/BuildDeeper/BuildDeeperImage.tsx







var BuildDeeperImage = function BuildDeeperImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((BuildDeeper_default()), ", ").concat((assets_BuildDeeper_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "608",
      src: (BuildDeeper_2x_default()),
      alt: "Illustration: Make it a continuous conversation",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var BuildDeeper_BuildDeeperImage = (BuildDeeperImage);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/components/BuildDeeper/BuildDeeper.tsx







var BuildDeeper_copy = {
  heading: "Build deeper customer relationships with Journeys",
  description: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
      tag: "p",
      children: "With Journeys, users can orchestrate highly sophisticated customer journeys, at scale, to deliver meaningful personalization campaigns on any channel, and across any connected application."
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
      tag: "p",
      children: "Segment\u2019s customer journey management tool allows businesses to adjust the customer experience in real-time, to reflect consumers\u2019 individual actions, preferences, and feedback. This allows teams to identify the most effective conversion drivers across the customer lifecycle."
    })]
  })
};

var BuildDeeper_BuildDeeper = function BuildDeeper() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuildDeeper_SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: BuildDeeper_copy.heading
        }), BuildDeeper_copy.description]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuildDeeper_BuildDeeperImage, {})
    })]
  });
};

var BuildDeeper_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1d7z8dn0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var components_BuildDeeper_BuildDeeper = (BuildDeeper_BuildDeeper);
// EXTERNAL MODULE: ./src/views/Product/TwilioEngagePage/Journeys/assets/OgJourneys.png
var OgJourneys = __webpack_require__(53744);
var OgJourneys_default = /*#__PURE__*/__webpack_require__.n(OgJourneys);
;// CONCATENATED MODULE: ./src/views/Product/TwilioEngagePage/Journeys/Journeys.tsx






















var JourneysView = function JourneysView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Journeys: Customer Journey Management Software | Twilio Segment",
      pageDescription: "Journeys from Twilio Segment is a complete customer journey management tool, allowing you to orchestrate omnichannel customer engagement.",
      pageOG: (OgJourneys_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial_Testimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_Video, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MakeItAContinuousConversation_MakeItAContinuousConversation, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_OrchestrateTheOutcomes_OrchestrateTheOutcomes, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_BuildDeeper_BuildDeeper, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UnitePaidAndOwnedChannels_UnitePaidAndOwnedChannels, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_Testimonials, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChooseYourOwnJourney_ChooseYourOwnJourney, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_FaqSection, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e91fwdv0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Journeys_Journeys = (JourneysView);
;// CONCATENATED MODULE: ./src/pages/product/twilio-engage/journeys.tsx



var Journeys = function Journeys() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Journeys_Journeys, {});
};

/* harmony default export */ var journeys = (Journeys);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 98960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead

var REGEX_PATTERN = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(REGEX_PATTERN, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx


var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react-hooks/exhaustive-deps */





























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(forbiddenEmail, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), _z$object));
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", ""); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Testimonial_Testimonial; }
});

// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 257 modules
var CompanyMono = __webpack_require__(41346);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 265 modules
var Company = __webpack_require__(28392);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/data.tsx





var data = [{
  company: "box",
  logoName: "Box",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BoxMonoLogo */.Xb7, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CCustomerAI Predictions has equipped Box\u2019s marketing team with the ability to forecast customer behavior to a degree that was simply unavailable to us before. We\u2019ve been able to explore segmenting our audience based on predictive traits like who is most likely to join us at in-person events or who is more likely to purchase, and this allows us to meet those people where they are in their customer journey.\u201D",
  name: "Chris Koehler",
  position: "CMO at Box"
}, {
  company: "vacasa",
  logoName: "Vacasa",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VacasaMonoLogo */.Ciy, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio and Segment enable Vacasa to understand the entire customer journey to more effectively deliver personalized messages to guests and remove friction from their vacation experience.\u201D",
  name: "G Scott",
  position: "Director of Marketing Analytics",
  extendedRate: "3x",
  extendedText: "more guest bookings with personalized campaigns",
  extendedLink: "/customers/vacasa/"
}, {
  company: "fox",
  logoName: "Fox",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FoxMonoLogo */.xrs, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "When you use any of our mobile apps, you should be greeted like an old friend. When we deliver an ad to you, it should be relevant. When we suggest content to you, it should be in line with your tastes. This is all thanks to Segment.",
  name: "Daryl Bowden",
  position: "Executive Vice President, Technology Platforms at FOX Corporation",
  extendedRate: "376",
  extendedRateSymbol: "",
  extendedText: "more visitors to FOX Sports \u201CFor You\u201D app"
}, {
  company: "bonobos",
  logoName: "Bonobos",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BonobosMonoLogo */.Trx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAs our business grows, it has become increasingly important to understand how online spend influences offline behavior, which Facebook and Segment have made possible.\u201C",
  name: "Micky Onvural",
  position: "Co-President",
  extendedRate: "3x",
  extendedText: "increase in offline purchases versus control group",
  extendedLink: "/customers/bonobos/"
}, {
  company: "ibm",
  logoName: "IBM",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* IbmMonoLogo */.cEr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith real-time integrated data flows from Segment, we can truly understand what people are doing with our platform.\u201D",
  name: "Nic Sauriol",
  avatar: "",
  position: "Software Development Leader",
  extendedRate: "70",
  extendedRateSymbol: "%",
  extendedText: "increase in revenue following a three-month customer messaging pilot program",
  extendedLink: "/customers/ibm/"
}, {
  company: "rugs-com",
  logoName: "Rugs.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RugsComMonoLogo */.ONK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment\u2019s first-party audience targeting capabilities directly improved our return on ad spend. With better performing Google and Facebook campaigns...we were able to reinvest part of our optimized ad budgets into other high growth initiatives.\u201D",
  name: "Grayson Bagwell",
  position: "Director of Business Development and E-Commerce",
  extendedRate: "400",
  extendedRateSymbol: "%",
  extendedText: "YoY revenue growth",
  extendedLink: "/customers/rugs-dot-com/"
}, {
  company: "digital-ocean",
  logoName: "DigitalOcean",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DigitalOceanMonoLogo */.G7L, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment allows us to be more precise with how we dynamically suppress or target users in ad campaigns based on actual product usage.\u201D",
  name: "Sam Coren",
  position: "Senior Demand Generation Manager",
  extendedRate: "33",
  extendedRateSymbol: "%",
  extendedText: "improvement in cost per conversion",
  extendedLink: "/customers/digital-ocean/"
}, {
  company: "pager-duty",
  logoName: "PagerDuty",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* PagerDutyMonoLogo */.e90, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUsing Pendo and Segment to create this onboarding flow, rather than building it out as part of the core PagerDuty product, saves valuable time for engineering.\u201D",
  name: "Hailey Hickman",
  position: "Program Manager",
  extendedRate: "178",
  extendedRateSymbol: "%",
  extendedText: "increase in mobile app downloads",
  extendedLink: "/customers/pagerduty/"
}, {
  company: "drift",
  logoName: "Drift",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DriftMonoLogo */.BPv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe're using Twilio Engage as our new-age CRM. We identify which prospects are most likely to convert by aggregating individual user intent signals for each account...\u201D",
  name: "Guillaume Cabane",
  position: "Former VP of Growth",
  extendedRateSymbol: "%",
  extendedRate: "150",
  extendedText: "increase in positive conversations in 2 months",
  extendedLink: "/customers/drift/"
}, {
  company: "dominos",
  logoName: "Domino's",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DominosMonoLogo */.ooH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Domino\u2019s turned to Twilio Segment to create a universal view of the customer, better visibility of ad campaign effectiveness, and create hyper personalized audiences with Twilio Engage to increase ROAS, revenue and incremental orders across all paid and owned e-commerce channels.",
  name: "",
  position: "Domino's",
  extendedRateSymbol: "%",
  extendedRate: "65",
  extendedText: "decrease in customer acquisition cost",
  extendedLink: "/customers/dominos/"
}, {
  company: "ab-in-bev",
  logoName: "ABInBev",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AbInBevMonoLogo */.gud, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201COur products are vital to our customers\u2019 businesses, and through BEES we\u2019ve empowered them to order the products their consumers love anytime, anywhere. Couple this with real time messaging about when their products will arrive, and what changes have taken place in the process, if any, has deepened our relationship with our customers immensely.\u201D",
  name: "Jason Lambert",
  position: "SVP Product at BEES",
  extendedRateSymbol: "",
  extendedRate: "$2",
  extendedText: "businesses buzzing through a next generation B2B platform with Twilio Segment",
  extendedLink: "/customers/ab-inbev/"
}, {
  company: "crypto-com",
  logoName: "Crypto.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CryptoComMonoLogo */.K9k, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe knew from day one that Twilio\u2019s solutions were the most qualified because our developers had first-hand experience, knowledge, and success working with them in the past.\u201D",
  name: "Matthew Chan",
  position: "Chief Technology Officer",
  extendedRateSymbol: "%",
  extendedRate: "900",
  extendedText: "forecasted increase in user-base by 2023",
  extendedLink: "/customers/crypto/"
}, {
  company: "earnest",
  logoName: "Earnest",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* EarnestMonoLogo */.Iei, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment provided Earnest with a single user identity and consistent, granular customer data that the team needed to create the advanced, customized metrics to scale the affiliate program.\u201D",
  name: "Goutham Valeti",
  position: "Head of Analytics",
  extendedRate: "10x",
  extendedText: "loan volume growth and saved borrowers well over $100M",
  extendedLink: "/customers/earnest/"
}, {
  company: "clear-score",
  logoName: "ClearScore",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ClearScoreMonoLogo */.Ojb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe cost of a Segment investment completely beat our in-house options out of the water. It was a no-brainer in terms of cost.\u201D",
  name: "Klaus Thorup",
  avatar: "",
  position: "Chief Technology Officer",
  extendedRate: "3x",
  extendedText: "cost savings with Twilio Segment instead of building in-house",
  extendedLink: "/customers/clearscore/"
}, {
  company: "toggle",
  logoName: "Toggle",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ToggleMonoLogo */.nSO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWhat we have in Segment is a platform for serendipity. We\u2019re able to react to many scenarios, innovate quickly, scale resources, and bolster a culture of digital transformation.\u201D",
  name: "Todd Wright",
  position: "Sr. Technologist",
  extendedRateSymbol: "%",
  extendedRate: "64",
  extendedText: "decrease in cost per acquisition",
  extendedLink: "/customers/toggle/"
}, {
  company: "stylepit",
  logoName: "Stylepit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* StylepitMonoLogo */.$K_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment proved to us that our first-party data was more valuable than any third-party data\u2014even third-party tracking cookies\u2014could provide.\"",
  name: "Martin Brummerstedt",
  position: "Data Scientist & Digital Project Manager",
  extendedRate: "1.7x",
  extendedText: "increase in ROAS",
  extendedLink: "/customers/stylepit/"
}, {
  company: "tradesy",
  logoName: "Tradesy",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradesyMonoLogo */.qKx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe played around and built a couple of prototypes for our own data pipeline, but we quickly realized that it would take three engineers six months to stabilize a platform, and even then it would not be as feature-rich as Segment.\u201D",
  name: "Geoff Apps",
  position: "CTO at Tradesy",
  extendedRate: "6",
  extendedText: "months saved in engineering time",
  extendedLink: "/customers/tradesy/"
}, {
  company: "frame-io",
  logoName: "FrameIo",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FrameIoMonoLogo */.QzL, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CFrame.io needed a definitive 'single source of truth' where they could unify diverse data sources that would provide the full picture of their customers and Twilio Segment provided that.\u201D",
  name: "Kyle Gesuelli",
  position: "Head of Growth",
  extendedRateSymbol: "%",
  extendedRate: 80,
  extendedText: "reduction in the handle time on support tickets",
  extendedLink: "/customers/frameio/"
}, {
  company: "retool",
  logoName: "Retool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RetoolMonoLogo */.U8Y, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAfter we looked at the costs of building the basic infrastructure and the support required, Twilio Segment became a no-brainer and we upgraded from their Startup Program.\u201D",
  name: "Jane Kelly",
  position: "Head of Growth",
  extendedRateSymbol: "",
  extendedRate: "1000+",
  extendedText: "Retool saved over 1,000 engineering hours by using Twilio Segment",
  extendedLink: "/customers/retool/"
}, {
  company: "meredith",
  logoName: "Meredith",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MeredithMonoLogo */.eqZ, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has enabled us to streamline the data capture process while maintaining flexibility to customize per brand as needed.\u201C",
  name: "Grace Preyapongpisan",
  position: "Vice President, Business Intelligence",
  extendedRate: 36,
  extendedText: "brands centralized on the same data analytics infrastructure",
  extendedLink: "/customers/meredith/"
}, {
  company: "candu",
  logoName: "Candu",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CanduMonoLogo */.IBI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe developer experience with Segment was super easy. Docs were robust enough for us to follow and build an integration within a day.\u201C",
  name: "Michele Riccardo Esposito",
  position: "Chief Technology Officer"
}, {
  company: "looker",
  logoName: "Looker",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LookerMonoLogo */.lpP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CHaving a consistent pipeline of clean and standardized first-party data from Segment is an extremely valuable and core data set for our customers\u2019 success.\u201C",
  name: "Keenan Rice",
  position: "VP Strategic Alliances"
}, {
  company: "trustpilot",
  logoName: "Trustpilot",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TrustpilotMonoLogo */.OPh, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment\u2019s Privacy Portal gives us the confidence to align our event data streams with our company\u2019s data privacy and governance standards. With real-time visibility across our event streams, we are able to proactively respect our customers\u2019 privacy.\u201C",
  name: "Rudy Martin",
  position: "Chief Information Security Office"
}, {
  company: "adviso",
  logoName: "Adviso",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdvisoMonoLogo */.HXI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWorking with Segment allows us to better serve our clients by delivering deeper insights, more quickly. Segment reduces time spent building data pipelines and allows us to provide access to reliable, clean, and actionable data to our customers.\u201C",
  name: "Louis-Philippe Mathieu",
  position: "Data Scientist"
}, {
  company: "prolific-interactive",
  logoName: "ProlificInteractive",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ProlificInteractiveMonoLogo */.BDm, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment understands the value of having their end-users be experts on the platform, and that remains a top priority for them. Instead of simply doing it for you, they take the time to guide you to a deeper level of understanding of the nuances of their platform.\u201C",
  name: "David Reyneke",
  position: "Sr. Growth Manager"
}, {
  company: "y-combinator",
  logoName: "YCombinator",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* YCombinatorMonoLogo */.ah_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment helps businesses set up analytics the way it was meant to be \u2014 quantifying product-market fit, understanding customers, and trying new tools \u2014 all without redundant or time-consuming work.\u201C",
  name: "Gustaf Alstr\xF6mer",
  position: "Partner at Y Combinator"
}, {
  company: "flowers-1800",
  logoName: "Flowers1800",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* Flowers1800MonoLogo */.QZv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Twilio Engage, we are able to collect, unify and connect customer data in real time and build meaningful relationships at every touchpoint of the customer journey. We\u2019re accelerating our digital business and data infrastructure by nearly a decade, and by doing so, delighting our customers.\u201C",
  name: "Amit Shah",
  position: "President"
}, {
  company: "shutterstock",
  logoName: "Shutterstock",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ShutterstockMonoLogo */.IcO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Shutterstock partnered with Segment to unlock the personalization power for their email campaigns. Segment\u2019s expertise accelerated the digital media marketplace\u2019s customer experience with contextually relevant messaging and a 30% lift in click rates."
}, {
  company: "typeform",
  logoName: "Typeform",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TypeformMonoLogo */.wJ3, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUntil we started standardizing our data, people didn\u2019t realize how messy it had become. With Protocols, we can be confident that data quality issues don\u2019t happen anymore.\u201D",
  name: "Colin Furlong",
  position: "Data Operations & Tracking",
  extendedRateSymbol: "%",
  extendedRate: 75,
  extendedText: "Reduction in duplicate or extraneous tracked events",
  extendedLink: "/customers/typeform/"
}, {
  company: "creative-market",
  logoName: "CreativeMarket",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CreativeMarketMonoLogo */.w1t, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CProtocols provides the context my teams need to effectively use our customer data in campaigns and analyses.\u201D",
  name: "Akshay Singh",
  position: "Former extended & Product Analytst",
  extendedRateSymbol: "%",
  extendedRate: 93,
  extendedText: "Reduction in time to detect data issues",
  extendedLink: "/customers/creative-market/"
}, {
  company: "allergan",
  logoName: "Allergan",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AllerganMonoLogo */.ubl, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe lean heavily on Segment today to identify our consumers and their profile traits, what makes them them, and what kind of journey they are on.\u201D",
  name: "Christine Li",
  position: "Director of Marketing Technology",
  extendedRate: "400M+",
  extendedText: "In sales driven in 2021 YTD by direct-to-consumer",
  extendedLink: "/customers/allergan/"
}, {
  company: "amboss",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AmbossMonoLogo */.D9K, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "Amboss",
  text: "\u201C[...]Twilio Segment has been game-changing, helping us to centralize our customer data far more quickly, efficiently and cost effectively than we could have imagined.\u201D",
  name: "Elmar Weber",
  position: "Chief Technical Officer",
  extendedText: "Reduced time to insights from days to minutes",
  extendedLink: "/customers/amboss/"
}, {
  company: "chopra",
  logoName: "Chopra",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ChopraMonoLogo */.aIE, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is significantly cheaper than having a full data team[...]and allowed us to see what our customers are actually doing.\u201D",
  name: "Josh Wexler",
  position: "Chief Product Officer",
  extendedText: "Maximized resources resulting in the building of data-driven products",
  extendedLink: "/customers/chopra/"
}, {
  company: "ritual",
  logoName: "Ritual",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RitualMonoLogo */.qWP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe use Segment as our CDP and the biggest thing it\u2019s given us is flexibility[...]to define what the ideal experience is for our customers.\u201D",
  name: "Laura Brodie",
  position: "Director of Customer Lifecycle and Growth",
  extendedText: "More agile audience development and increased LTV over time",
  extendedLink: "/customers/ritual/"
}, {
  company: "theVintageBar",
  logoName: "TheVintageBar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheVintageBarMonoLogo */.u$x, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has empowered our company to make decisions smarter and faster to give our customers the best experience possible. With constant experimentation, sophisticated customer data models, and journey mapping, we can deliver personalization at scale and across all channels.\u201D",
  name: "Nikolaj Toxv\xE6rd",
  position: "Chief Marketing Officer",
  extendedRate: "6x",
  extendedText: "inventory growth in 6 months with optimized experiences",
  extendedLink: "/customers/the-vintage-bar/"
}, {
  company: "good-eggs",
  logoName: "GoodEggs",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* GoodeggsMonoLogo */.nCX, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment has proven not only to be simple, fast, and reliable \u2014 but also an accelerant. Engineering can now focus on features and use cases, rather than infrastructure to get our events from the edge to downstream systems.\"",
  name: "Bob Zoller",
  position: "Founding Engineer",
  extendedRate: "0 Hours",
  extendedText: "engineering time spend managing data pipelines",
  extendedLink: "/customers/goodeggs/"
}, {
  company: "halp",
  logoName: "Halp",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* HalpMonoLogo */.JRr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Using Segment, you save a combination of time and money.\"",
  name: "Fletcher Richman",
  position: "CEO and Co-Founder",
  extendedRate: "4x",
  extendedText: "improvement in the number of activated sign-ups",
  extendedLink: "/customers/halp/"
}, {
  company: "craft-jack",
  logoName: "CraftJack",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CraftJackMonoLogo */.Vsb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"With Twilio Engage, we are able to do the work of three or four different tools, all in one centralized platform. We are able to bring transactional conversation and personalized marketing messages all into Twilio Engage for greater efficiency.\"",
  name: "Jordan Dietch",
  position: "VP of Product Management, CraftJack",
  extendedText: "31% increase in new user signups YoY and 80% increase in engineering implementation efficiency",
  extendedLink: "/customers/craftjack/"
}, {
  company: "mongodb",
  logoName: "mongodb",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSince implementing Segment we have seen a significant increase in revenue which we attribute to the improved targeting and personalization of our communications.\u201D"
}, {
  company: "sanofi",
  logoName: "sanofi",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SanofiMonoLogo */.he8, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe process before Segment was much more cumbersome and difficult to explain to marketers. Now, Segment allows us to compile data all in one place, forming a Golden Profile, and allows for other teams to easily utilize and activate data.\u201D"
}, {
  company: "the-motley-fool",
  logoName: "the-motley-fool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheMotleyFoolMonoLogo */.DeK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is much more of a self-service platform. Whereas before we were limited in how we could message or target prospects and members, we can now build and activate audiences almost immediately.\u201D"
}, {
  company: "univision",
  logoName: "univision",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* UnivisionMonoLogo */.KML, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CRegardless of scale, Segment provides you the tools and platform to move quickly and efficiently. We couldn\u2019t\n    have done this any other way.\u201C"
}, {
  company: "crossfit",
  logoName: "crossfit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CrossFitMonoLogo */.DvB, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CNow, our data and teams are cohesive and connected, we can make data driven decisions and reach our customers\n    effectively.\u201C"
}, {
  company: "arduino",
  logoName: "arduino",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ArduinoMonoLogo */.Yt2, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CA big benefit of Segment is being able to activate our first-party data all in one platform. Our previous\n    tool required more manual effort, and therefore limited our marketing communication options\u201C"
}, {
  company: "fender",
  logoName: "Fender",
  text: "To increase adoption and retention rates, Fender also uses tools from Twilio Segment to optimize the customer\n    sales funnel by streamlining the onboarding process.",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FenderMonoLogo */.bf1, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  name: "",
  position: "",
  extendedRate: "29%",
  extendedText: "reduction in customer churn rate for paid app",
  extendedLink: "/customers/fender"
}, {
  company: "trademe",
  logoName: "TradeMe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradeMeMonoLogo */.KH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe marketing team has been making very good use of CustomerAI Predictions, and we are keen on continuing to use it to drive campaigns across digital channels.\u201D"
}, {
  company: "camping-world",
  logoName: "CampingWorld",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CampingWorldMonoLogo */.H1r, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Engage allows Camping World to track events like \u2018RV model viewed\u2019 and \u2018RV added to favorites list\u2019 to create profiles, then utilize this information to craft specific omni-channel messages.\u201D"
}, {
  company: "adevinta",
  logoName: "Adevinta",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdevintaMonoLogo */.fGv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "With Segment at its core, Adevinta will enable cross-organizational collaboration through standardized data leading to relevant, personalized customer touch points across all its channels."
}, {
  company: "vervoe",
  logoName: "Vervoe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VervoeMonoLogo */.VhY, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe rely on Segment pretty heavily to feed all of the platforms to understand where the breakdowns are within the customer journey.\u201D"
}, {
  company: "tillster",
  logoName: "Tillster",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TillsterMonoLogo */.Tys, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Segment, we are able to use more personalization and intelligent targeting\u201C"
}, {
  company: "smartcar",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBuilding a user-friendly API isn\u2019t always easy\u2014especially if you want to appeal to your users and their users. Thanks to Twilio Segment, we can focus on both areas in one go, and give our team the chance to measure and evaluate the things they feel are most important.\u201D"
  }),
  name: "Sanketh Katta",
  position: "CTO and co-founder, Smartcar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SmartcarMonoLogo */.DXF, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SmartcarLogo */.GQ7, {}),
  logoName: "Smartcar",
  extendedRate: "22%",
  extendedText: "improvement in developer application conversions",
  extendedLink: "/customers/smartcar/"
}, {
  company: "lens-online",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CWhile our previous tech stack, including a CRM, SAP, Zendesk, etc. supported our early growth, it wasn't enough for our future ambitions. We needed to not just understand but anticipate our customer's needs. This realization led us to Twilio Segment, moving beyond traditional CRMs to a 360-degree view of customers, integrating every customer interaction and preference with a customer data platform.\u201D"
  }),
  name: "Pascal",
  position: "CMO & CDO, LensOnline",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LensOnlineMonoLogo */.FRf, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* LensOnlineLogo */.vmS, {}),
  logoName: "Fender",
  extendedRate: "15%",
  extendedText: "reduction in marketing spend",
  extendedLink: "/customers/lens-online/"
}, {
  company: "veronica-beard",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBased on our research, we know that omnichannel customers are our most valuable customers. Because of this, we build Twilio Engage Audiences of our omnichannel customers and top customers in lifetime revenue, to use as the basis for lookalike audiences in Facebook Ads.\u201D"
  }),
  name: "Maxime Lagresle",
  position: "Ecommerce Analytics Manager",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VeronicaBeardMonoLogo */.i_T, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "VeronicaBeard",
  extendedRate: "20% ",
  extendedText: "Reduction in customer acquisition costs (CAC) from Facebook Ads",
  extendedLink: "/customers/veronica-beard/"
}];
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/Testimonial.tsx







var TestimonialTemplate = function TestimonialTemplate(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "base" : _ref$variant,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? variant === "extended" ? "460px" : "auto" : _ref$height,
      overrides = _ref.overrides,
      company = _ref.company,
      color = _ref.color,
      logo = _ref.logo,
      text = _ref.text,
      avatar = _ref.avatar,
      name = _ref.name,
      position = _ref.position,
      extendedRate = _ref.extendedRate,
      extendedRateSymbol = _ref.extendedRateSymbol,
      extendedText = _ref.extendedText,
      extendedLink = _ref.extendedLink;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var companyData = data.find(function (item) {
    return item.company === company;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* default */.ZP, {
    variant: variant,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
      color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
      overrides: overrides,
      height: height,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
          children: (companyData === null || companyData === void 0 ? void 0 : companyData.logo) || logo
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
          children: text || (companyData === null || companyData === void 0 ? void 0 : companyData.text)
        })]
      }), (name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseAuthorSlot */.hC, {
        children: [(avatar || (companyData === null || companyData === void 0 ? void 0 : companyData.avatar)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorAvatar */.DV, {
          alt: "Portrait of" + name,
          src: avatar || String(companyData === null || companyData === void 0 ? void 0 : companyData.avatar)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
            children: name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
            children: position || (companyData === null || companyData === void 0 ? void 0 : companyData.position)
          })]
        })]
      })]
    }), variant === "extended" && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Extended */.jW, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedTextSlot */.VJ, {
        children: [(extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedHeader */.S2, {
          color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
          children: [extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate), (extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedHeaderSup */.Jk, {
            children: extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedText */.wN, {
          children: extendedText || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedText)
        })]
      }), (extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButtonSlot */.Wi, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedStoryLink */.c9, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButton */.Di, {
            colored: Boolean(color),
            href: (0,getAbsoluteUrl/* default */.Z)(extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink) || "", pageConfig),
            text: "Read their story"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Testimonial_Testimonial = (TestimonialTemplate);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 75730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/twilio-engage/journeys",
      function () {
        return __webpack_require__(30866);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 53744:
/***/ (function(module) {

module.exports = "/_next/static/images/OgJourneys-877025f99206c91ebf9dbbb09266c245.png";

/***/ }),

/***/ 85806:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildDeeper@2x-b36d854e98adee139a5a1084456fb7e9.png";

/***/ }),

/***/ 57766:
/***/ (function(module) {

module.exports = "/_next/static/images/CartAbandonmentDesktop-d94d74735940b0018e9a148333ddd750.png";

/***/ }),

/***/ 35811:
/***/ (function(module) {

module.exports = "/_next/static/images/CartAbandonmentMobile-03425f2742d0fbc99f2030ab836737c2.png";

/***/ }),

/***/ 18564:
/***/ (function(module) {

module.exports = "/_next/static/images/LowRecencyPurchaseWinbackDesktop-153afa48d555e39e0b3fb6d79c535e99.png";

/***/ }),

/***/ 24924:
/***/ (function(module) {

module.exports = "/_next/static/images/LowRecencyPurchaseWinbackMobile-8c6deef9990b9290c5751fac26e9087d.png";

/***/ }),

/***/ 18093:
/***/ (function(module) {

module.exports = "/_next/static/images/OnboardingDesktop-eaac3d13241f20bb77644e07a03a1e26.png";

/***/ }),

/***/ 58015:
/***/ (function(module) {

module.exports = "/_next/static/images/OnboardingMobile-b07d226638b83f6d693e96c5a295a518.png";

/***/ }),

/***/ 43400:
/***/ (function(module) {

module.exports = "/_next/static/images/PaidSubscriptionAcquisitionDesktop-0fa0f72d7dd682b4e4020ce24419612f.png";

/***/ }),

/***/ 26910:
/***/ (function(module) {

module.exports = "/_next/static/images/PaidSubscriptionAcquisitionMobile-fbf5538932c79c15d00eb128546b28dd.png";

/***/ }),

/***/ 1736:
/***/ (function(module) {

module.exports = "/_next/static/images/ReEngagementDesktop-9ed54975d97c2e5b84b9121890f90baf.png";

/***/ }),

/***/ 13842:
/***/ (function(module) {

module.exports = "/_next/static/images/ReEngagementMobile-46329b296494c2e885e5302fc86a1dbf.png";

/***/ }),

/***/ 17436:
/***/ (function(module) {

module.exports = "/_next/static/images/RepeatPurchaseCampaignsDesktop-4194ac775b556a38e17886a30f95f6c4.png";

/***/ }),

/***/ 87534:
/***/ (function(module) {

module.exports = "/_next/static/images/RepeatPurchaseCampaignsMobile-22656e4669d8019160897c17e1657328.png";

/***/ }),

/***/ 38267:
/***/ (function(module) {

module.exports = "/_next/static/images/TrialToPaidConversionDesktop-bba5844d7680d3f0aa21e12cdf58a594.png";

/***/ }),

/***/ 84738:
/***/ (function(module) {

module.exports = "/_next/static/images/TrialToPaidConversionMobile-6141d9d72919d4b4fe4345f67a293408.png";

/***/ }),

/***/ 29412:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-747a91c18edfbd0fa6b341a1eb530ad1.png";

/***/ }),

/***/ 51318:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeItAContinuousConversation@2x-c3d13844d060a865c00522aff06b005d.png";

/***/ }),

/***/ 1504:
/***/ (function(module) {

module.exports = "/_next/static/images/OrchestrateTheOutcomes@2x-2073a893f701a52e6fe4b01ad3dca76d.png";

/***/ }),

/***/ 52196:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannels-f8daf38dc9074aa1f724752765c5edfb.png";

/***/ }),

/***/ 8977:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannels@2x-38d3d44f43056d23bba285fbfd5f6a2c.png";

/***/ }),

/***/ 57014:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannelsMobile@2x-d74ef93183f017c5ed1038ef7ddf0e0e.png";

/***/ }),

/***/ 92179:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-e35cc87b6d6ec479c91792efc740d1ff.png";

/***/ }),

/***/ 50444:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildDeeper-a401dfe07bdb5fd0a61a99fcbc180bb6.webp";

/***/ }),

/***/ 42138:
/***/ (function(module) {

module.exports = "/_next/static/images/BuildDeeper@2x-5ed4bd7071bdd05bc9215ed6d1d91895.webp";

/***/ }),

/***/ 11432:
/***/ (function(module) {

module.exports = "/_next/static/images/CartAbandonmentDesktop-b005a871c985c8e622cccc2299e10580.webp";

/***/ }),

/***/ 27144:
/***/ (function(module) {

module.exports = "/_next/static/images/CartAbandonmentMobile-f6eca5f9e02103308491a4a30ac878f9.webp";

/***/ }),

/***/ 25265:
/***/ (function(module) {

module.exports = "/_next/static/images/LowRecencyPurchaseWinbackDesktop-22e3304258f9eff24fa9421a699e9bb0.webp";

/***/ }),

/***/ 66558:
/***/ (function(module) {

module.exports = "/_next/static/images/LowRecencyPurchaseWinbackMobile-8c648d6f34989e68356f3925b3fecae8.webp";

/***/ }),

/***/ 54872:
/***/ (function(module) {

module.exports = "/_next/static/images/OnboardingDesktop-e98db61256440b0fd9f8289766eb6063.webp";

/***/ }),

/***/ 99188:
/***/ (function(module) {

module.exports = "/_next/static/images/OnboardingMobile-41a0dabbe09b3ca9c166ced8324f447c.webp";

/***/ }),

/***/ 53194:
/***/ (function(module) {

module.exports = "/_next/static/images/PaidSubscriptionAcquisitionDesktop-9cd529be56ababfa8822c7a9c555244f.webp";

/***/ }),

/***/ 28807:
/***/ (function(module) {

module.exports = "/_next/static/images/PaidSubscriptionAcquisitionMobile-7b584dfb2b3d0b63319592f250809226.webp";

/***/ }),

/***/ 414:
/***/ (function(module) {

module.exports = "/_next/static/images/ReEngagementDesktop-c5b600cd8d0a168315e09e6f54d377e0.webp";

/***/ }),

/***/ 27643:
/***/ (function(module) {

module.exports = "/_next/static/images/ReEngagementMobile-0c9b5c6bf1b0dedb8c2b2575db4fd9ac.webp";

/***/ }),

/***/ 43576:
/***/ (function(module) {

module.exports = "/_next/static/images/RepeatPurchaseCampaignsDesktop-60aaacc5ebfbabcac6426798bbefeedf.webp";

/***/ }),

/***/ 82052:
/***/ (function(module) {

module.exports = "/_next/static/images/RepeatPurchaseCampaignsMobile-bce8f267500a7dbecf367acb36a9cffb.webp";

/***/ }),

/***/ 18470:
/***/ (function(module) {

module.exports = "/_next/static/images/TrialToPaidConversionDesktop-72a966eec4d280f9e5ae2cc27b4619dc.webp";

/***/ }),

/***/ 71536:
/***/ (function(module) {

module.exports = "/_next/static/images/TrialToPaidConversionMobile-918a82a6ec47c7e1a8abab9f750a9def.webp";

/***/ }),

/***/ 83820:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-e637457bb0f73cffd5d393bcf3af9716.webp";

/***/ }),

/***/ 47096:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-990ca9a7cb047883c1d51d02f32b7973.webp";

/***/ }),

/***/ 16116:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeItAContinuousConversation-382e02b8094b104651b3f44585a4e8ab.webp";

/***/ }),

/***/ 38456:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeItAContinuousConversation@2x-7464bd5d88b34e53c3e932f77d732e99.webp";

/***/ }),

/***/ 8801:
/***/ (function(module) {

module.exports = "/_next/static/images/OrchestrateTheOutcomes-3a93521bbca3b7d287b0aa4fa48155cb.webp";

/***/ }),

/***/ 75720:
/***/ (function(module) {

module.exports = "/_next/static/images/OrchestrateTheOutcomes@2x-a570ee360e1e8698afea6bcae18ea59e.webp";

/***/ }),

/***/ 98546:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannels-d62fa83dfa4bf1025f117f869c236f26.webp";

/***/ }),

/***/ 3079:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannels@2x-7b6d7a1c19d3b870d064b7806b363dcb.webp";

/***/ }),

/***/ 23910:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannelsMobile-0a007b6306f5e64762ae7ca3e7dc837b.webp";

/***/ }),

/***/ 70168:
/***/ (function(module) {

module.exports = "/_next/static/images/UnitePaidAndOwnedChannelsMobile@2x-32b0467cc645b9e0e37f904fe5cf9487.webp";

/***/ }),

/***/ 25149:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover-e90fc08f6ab940d33301d6d85fe53725.webp";

/***/ }),

/***/ 35816:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-7abd7e880cb8d03c0b4b259ab83e9333.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,3607,3254,9129,1752,1382,4136,2073,4274,7096,2429,1367,948,7303,3996,8187,8726,7960,6012,442,8392,1346,5062,814,9774,2888,179], function() { return __webpack_exec__(75730); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);